module.exports = __webpack_public_path__ + "static/media/gambling-payout.08aae669.svg";